<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout column fill-height class="customer-page">
    <v-flex shrink>
      <!-- 테스크탑 바 -->
      <DesktopBar/>
    </v-flex>
    <v-flex class="grow" style="background-color: #fafafa;">
      <v-container fill-height :style="'max-width:' + $vuetify.breakpoint.thresholds.md + 'px'">
        <v-layout column>
          <v-flex class="shrink text-xs-center">
            <h1>
              <strong>
                <span class="py-4">고객센터</span>
              </strong>
            </h1>
          </v-flex>
          <v-divider class="my-3"></v-divider>
          <v-flex class="grow">
            <div class="contents-box">
              <v-layout row wrap align-start justify-space-around>
                <v-flex class="item-box shrink text-xs-center" @click="contentType = 'map'">
                  <div>
                    <v-icon size="48" class="icon">phone</v-icon>
                  </div>
                  <div class="item-name">
                    전화상담
                  </div>
                  <div class="item-info">
                    <span class="headline"><strong><a :href="'tel:' + config.company.customerNumber" class="text-point">{{config.company.customerNumber}}</a></strong></span><br>
                    <span class="nowrap">{{config.company.customerTime}}</span>
                  </div>
                </v-flex>
                <v-flex class="item-box shrink text-xs-center" @click="kakaoChat()">
                  <div>
                    <v-icon size="48" class="icon">question_answer</v-icon>
                  </div>
                  <div class="item-name">
                    1:1 채팅 상담
                  </div>
                  <div class="item-info">
                    1:1 채팅으로 편리하고 부담없는 상담받기
                  </div>
                </v-flex>
                <v-flex class="item-box shrink text-xs-center" @click="contentType = 'faq'">
                  <div>
                    <v-icon size="48" class="icon">insert_comment</v-icon>
                  </div>
                  <div class="item-name">
                    자주하는질문
                  </div>
                  <div class="item-info">
                    기다릴 필요없이 빠른 궁금증 해결하기
                  </div>
                </v-flex>
                <v-flex class="item-box shrink text-xs-center" @click="contentType = 'notice'">
                  <div>
                    <v-icon size="48" class="icon">notification_important</v-icon>
                  </div>
                  <div class="item-name">
                    공지사항
                  </div>
                  <div class="item-info">
                    사이트 주요 이용 안내사항 보러가기
                  </div>
                </v-flex>
              </v-layout>
            </div>

            <!-- 맵 -->
            <div class="contents-box mt-3" v-if="contentType === 'map'">
              <v-layout class="column wrap">
                <v-flex class="shrink text-xs-left">
                  <h2>
                    <strong>
                      <span class="py-4">오시는길</span>
                    </strong>
                  </h2>
                </v-flex>
                <v-divider class="my-3"></v-divider>
                <v-flex>
                  <div class="mini-map">
                    <div class="info-box elevation-5">
                      <span class="font-weight-medium" style="font-size: 16px;">{{config.company.name}}</span><br>
                      <span class="font-weight-light" style="font-size: 14px;" v-html="config.company.addr"></span>
                    </div>
                    <mini-map ref="minimap"
                              :appKey="map.appKey"

                              :center="map.center"
                              :level="map.level"
                              :mapTypeId.sync="map.mapTypeId"
                              :libraries="map.libraries"

                              @load="onLoad"
                              @zoom_start="onMapEvent('zoom_start', $event)"
                              @zoom_changed="onMapEvent('zoom_changed', $event)"
                              @click="onMapEvent('click', $event)"
                              @dblclick="onMapEvent('dblclick', $event)"
                              @rightclick="onMapEvent('rightclick', $event)"
                              @dragstart="onMapEvent('dragstart', $event)"
                              @dragend="onMapEvent('dragend', $event)"
                              @idle="onMapEvent('idle', $event)"
                              @maptypeid_changed="onMapEvent('maptypeid_changed', $event)"

                              style="position:relative; height: 100%;">
                    </mini-map>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <!-- 자주하는질문 -->
            <div class="contents-box mt-3" v-if="contentType === 'faq'">
              <v-layout class="column wrap">
                <v-flex class="shrink text-xs-left">
                  <h2>
                    <strong>
                      <span class="py-4">자주하는질문</span>
                    </strong>
                  </h2>
                </v-flex>
                <v-divider class="my-3"></v-divider>
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content
                      v-for="(item,i) in faq_data"
                      :key="i"
                    >
                      <template v-slot:actions>
                        <v-icon color="primary">$vuetify.icons.expand</v-icon>
                      </template>
                      <template v-slot:header>
                        <div>
                          <v-avatar color="title_dark1" size="28" class="mr-2">
                            <span class="white--text body-1">Q</span>
                          </v-avatar>
                          <span>{{item.subject}}</span>
                        </div>
                      </template>
                      <v-card>
                        <v-card-text class="grey lighten-3 pa-5">
                          <v-avatar color="red" size="28" class="mr-2">
                            <span class="white--text body-1">A</span>
                          </v-avatar>
                          <span v-html="item.contents"></span>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </div>
            <!-- 공지사항 -->
            <div class="contents-box mt-3" v-if="contentType === 'notice'">
              <v-layout class="column wrap">
                <v-flex class="shrink text-xs-left">
                  <h2>
                    <strong>
                      <span class="py-4">공지사항</span>
                    </strong>
                  </h2>
                </v-flex>
                <v-divider class="my-3"></v-divider>
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content
                      v-for="(item,i) in notice_data"
                      :key="i"
                    >
                      <template v-slot:header>
                        <div>
                          <v-avatar color="#bbb" size="28" class="mr-2">
                            <span class="white--text body-1">!</span>
                          </v-avatar>
                          <span>{{item.subject}}</span>
                        </div>
                      </template>
                      <v-card>
                        <v-card-text class="grey lighten-3 pa-5" v-html="item.contents"></v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-flex class="shrink">
      <!-- 하단내용 -->
      <Footer/>
    </v-flex>
  </v-layout>
</template>

<script>
import DesktopBar from './layout/DesktopBar'
import Footer from './layout/Footer'

// import EventBus from '@/utile/eventBus'
import MiniMap from '@/components/plugin/KakaoMap'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Customer',
  data: () => ({
    contentType: 'map',
    // 맵
    map: {
      appKey: '',
      center: { lat: 37.4803073, lng: 126.9328443 },
      level: 4, // 기본 3
      mapTypeId: MiniMap.MapTypeId.NORMAL,
      libraries: [ 'services' ],
      mapObject: null,
      geocoder: null,
      roadviewArea: false,
      polygon: null
    },
    notice_data: [],
    faq_data: []
  }),
  computed: {
    ...mapState({
      auth: state => state.auth,
      board: state => state.board,
      config: state => state.config
    })
  },
  created () {
    this.map.appKey = this.config.kakaRestApiAppKey
  },
  mounted () { // 시작
    // 맵 로드
    this.$refs.minimap.init()
    // 게시판 로드
    this.faqListUpdate()
    this.noticeListUpdate()
  },
  methods: { // 메소드
    ...mapActions({
      requestBoardData: 'board/requestBoardData'
    }),
    kakaoChat () {
      window.open('https://pf.kakao.com/_WcBHj/chat', '_blank')
    },
    /* 맵 온로드 */
    onLoad (map) {
      // console.log('on cus : ' + this.config.company.addr)
      this.map.mapObject = map
      this.$refs.minimap.addressSearch(this.config.company.addr)
    },
    /* 맵 이벤트 */
    onMapEvent (event, params) {
      //
    },
    faqListUpdate () {
      this.requestBoardData({ 'type': 'faqList' }).then((data) => {
        if (data.array.length > 0) {
          const _this = this
          data.array.forEach(function (value) {
            _this.faq_data.push(value)
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    noticeListUpdate () {
      this.requestBoardData({ 'type': 'noticeList' }).then((data) => {
        if (data.array.length > 0) {
          const _this = this
          data.array.forEach(function (value) {
            _this.notice_data.push(value)
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  components: {
    DesktopBar,
    Footer,
    MiniMap
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer.vue